export const isStringEmpty = (str: string | undefined) => !str || str.length === 0;

export function isPlainObject(item: unknown): item is Record<keyof any, unknown> {
	return item !== null && typeof item === 'object' && item.constructor === Object;
}